import { render, staticRenderFns } from "./MeasurementSpecificationTemplateEditModal.vue?vue&type=template&id=80e72bb8"
import script from "./MeasurementSpecificationTemplateEditModal.vue?vue&type=script&lang=ts"
export * from "./MeasurementSpecificationTemplateEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports